<template>
  <section class="bundle-card d-flex flex-column">
    <BundlePanel :bundle="item" />

    <WorkpackagesActive v-if="isPanelExpanded" class="mt-3" is-link :show-toolbar="false" />
  </section>
</template>

<script>
import { mapState } from 'pinia';
import { useBundlesStore } from '@/stores/bundles';

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapState(useBundlesStore, ['isWorkpackagePanelExpanded', 'selectedBundle']),

    isPanelExpanded() {
      return this.isWorkpackagePanelExpanded && this.selectedBundle._id === this.item._id;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@style/base/_variables.scss';

.bundle-card {
  border-top: 3px solid $assortment-bundle-border-colour;
}
</style>
